export const DATA_TESTID_ATTRIBUTE = 'data-testid'
export const DATA_TEST_ATTRIBUTE = 'data-test'
